import Observable from './Observable';

class Image extends Observable {
  static EVENT = {
    LOAD: 'onload',
    ERROR: 'onerror',
  };

  private readonly id: string;

  private readonly url: string = '';

  private element: HTMLImageElement = new window.Image();

  constructor(id: string, url: string) {
    super();
    this.url = url;
    this.id = id;
  }

  public load = (): this => {
    const img = new window.Image();
    img.src = this.url;
    img.style.width = '100%';
    img.style.height = 'auto';
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    img.addEventListener('load', () => {
      this.dispatchEvent(Image.EVENT.LOAD, {});
    });
    img.addEventListener('error', () => {
      this.dispatchEvent(Image.EVENT.ERROR, new Error('Error fetching of image'));
    });
    this.element = img;
    return this;
  };

  public getElement = (): HTMLImageElement => {
    const isMounted = (this.element as HTMLImageElement).parentElement;
    if (!isMounted) {
      return this.element;
    }
    return (this.element.cloneNode() as HTMLImageElement);
  };

  public destroy = () => {
  };
}

export default Image;
